import axiosInterceptor from './axiosInterceptor/index';
import { getHeaders } from '../utils/utils';

export const saveOnboardingSurvey = async (data) => {
  const headers = getHeaders();
  const res = await axiosInterceptor.post('/api/survey/onboarding', data, { headers });
  return res.data;
};
